import React from 'react';
import '../../components/Testimonial/Testimonial.css';
import Testimonialimg from '../../assets/images/Testimonial.png';
import Image1 from '../../assets/images/Indus Tubes.webp';
import Image2 from '../../assets/images/Jindal.webp';
import Image3 from '../../assets/images/Rashmi metaliks.webp';
import Image4 from '../../assets/images/Sail.webp';
import Image5 from '../../assets/images/Surya_1.webp';
import Image6 from '../../assets/images/Vedanta.webp';
import '../../styles/CustomClassCss/Custom.css';
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const Testimonial = () => {

  const settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    customPaging: (i) => (
      <div className="custom-dot">
        <span></span>
      </div>
    ),
    dotsClass: "custom-dots",
  };

  const testimonials = [
    {
      content: "They are not only recognized for their high-quality products but also for their exceptional services and client-centric approach. They go out of their way to ensure their clients are happy and satisfied.",
      author: "Mohit Mehrauli"
    },
    {
      content: "StelMart has been our reliable supplier partner, providing high-quality products. We are truly pleased with our association with them.",
      author: "Pankaj Kapoor"
    },
    {
      content: "The quality of the product offered is quite amazing, with the best prices. I would definitely choose and recommend it to others as well.",
      author: "Simran Kaushik"
    },
    {
      content: "Choose StelMart without giving it a second thought. It helps in fulfilling the requirements of the customers, making them happy throughout.",
      author: "Rahul Kumar"
    },
    {
      content: "The focus of StelMart is to keep the customer engaging with the quality products, offering reasonable prices.",
      author: "Sneha Singh"
    }
  ];

  const setting = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,  
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 2000, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,  
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,  
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div>
      <div className="container ">
        <div>
          <div className="team-header custom-inner-space custom-container-upper">
            <h2 className="meet-top font-poppins">05. Our Testimonial</h2>
            {/* <a href="#" className="view-all">
              VIEW ALL
            </a> */}
          </div>
          <section className="testimonial-section custom-inner-space ">
            <div className="testimonial-container">
              <div className="left-content">
                <div className="rating-container font-poppins">
                  <div className="stars">
                    <span className="star">★</span>
                    <span className="star">★</span>
                    <span className="star">★</span>
                    <span className="star">★</span>
                    <span className="star">★</span>
                  </div>
                  <p className="rating-text">
                  Customer satisfaction is reflected in the positive feedback and testimonials received for the services.                  </p>
                </div>
              </div>
              <div className="testimonial-carousel right-content ">
                <Slider {...settings}>
                  {testimonials.map((testimonial, index) => (
                    <div key={index} className="carousel-slide">
                      <div className="carousel-content">
                        <div className="carousel-image-container">
                          <img
                            src={Testimonialimg}
                            alt={`Testimonial ${index + 1}`}
                            className="carousel-image"
                          />
                        </div>

                        <div className="testimonial-text">
                          <div className="quote-icon-container">
                            <BiSolidQuoteAltLeft className="quote-icon" />
                          </div>
                          <p className="font-poppins">
                            "{testimonial.content}"
                          </p>
                          <span className="font-poppins">
                            {testimonial.author}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </section>
        </div>
        <div className="five-grid-sectionss custom-container-upper">
          <Slider {...setting} >
            <div className="grid-item ">
              <img src={Image1} alt="Feature 1" />
            </div>
            <div className="grid-item">
              <img src={Image2} alt="Feature 2" />
            </div>
            <div className="grid-item">
              <img src={Image3} alt="Feature 3" />
            </div>
            <div className="grid-item">
              <img src={Image4} alt="Feature 4" />
            </div>
            <div className="grid-item">
              <img src={Image5} alt="Feature 5" />
            </div>
            <div className="grid-item">
              <img src={Image6} alt="Feature 6" />
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;